import PromoRight from "@/components/header/promo/promo-right";
import PromoLeft from "@/components/header/promo/promo-left";
import React from "react";

function Promo() {
    return <div className="bg-mainBg text-themeP text-[14px]">
        <div className="w-fit h-promo bg-mainBg flex mx-auto">
            <div className="b-flex container">
                <PromoLeft/>
                <PromoRight className="e-flex space-x-4 text-black"/>
            </div>
        </div>
    </div>;
}

export default React.memo(Promo);
